import React from 'react';
export function Solution() {
  return <section id="solution" className="w-full py-12 md:py-24 bg-gradient-to-br from-pink-50 to-purple-50" data-id="element-155">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-156">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-12 items-center" data-id="element-157">
          <div className="flex flex-col justify-center space-y-4" data-id="element-158">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-159">
              The Breakthrough: Adaptogens
            </h2>
            <p className="text-gray-500 md:text-xl" data-id="element-160">
              When I hit my limit, I went deep into the science. What I found
              changed everything:
            </p>
            <p className="text-gray-500 md:text-xl" data-id="element-161">
              <span className="font-bold" data-id="element-162">Adaptogens</span> — ancient herbs and
              mushrooms that boost your body's natural ability to handle stress
              and produce sustainable energy.
            </p>
            <p className="text-gray-500 md:text-xl" data-id="element-163">
              These aren't biohacks. They're time-tested tools:
            </p>
            <ul className="space-y-2 text-gray-500 md:text-xl" data-id="element-164">
              <li className="flex items-center" data-id="element-165">
                <span className="mr-2 text-pink-600 font-bold" data-id="element-166">•</span>
                <span data-id="element-167">
                  <strong data-id="element-168">Lion's Mane:</strong> supports brain function and
                  mental clarity
                </span>
              </li>
              <li className="flex items-center" data-id="element-169">
                <span className="mr-2 text-pink-600 font-bold" data-id="element-170">•</span>
                <span data-id="element-171">
                  <strong data-id="element-172">Cordyceps:</strong> enhances stamina at the cellular
                  level
                </span>
              </li>
              <li className="flex items-center" data-id="element-173">
                <span className="mr-2 text-pink-600 font-bold" data-id="element-174">•</span>
                <span data-id="element-175">
                  <strong data-id="element-176">Ashwagandha:</strong> lowers cortisol, promotes calm
                  alertness
                </span>
              </li>
              <li className="flex items-center" data-id="element-177">
                <span className="mr-2 text-pink-600 font-bold" data-id="element-178">•</span>
                <span data-id="element-179">
                  <strong data-id="element-180">Rhodiola:</strong> combats fatigue and enhances
                  cognitive performance
                </span>
              </li>
            </ul>
            <p className="text-pink-600 font-medium md:text-xl" data-id="element-181">
              I didn't want to fake energy anymore. I wanted to build it.
            </p>
          </div>
          <div className="mx-auto flex items-center justify-center" data-id="element-182">
            <div className="relative h-[400px] w-[350px] overflow-hidden rounded-xl shadow-xl" data-id="element-183">
              <img src="https://images.unsplash.com/photo-1471193945509-9ad0617afabf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1760&q=80" alt="Natural adaptogenic ingredients" className="absolute inset-0 object-cover w-full h-full" data-id="element-184" />
            </div>
          </div>
        </div>
        <div className="mt-20" data-id="element-185">
          <div className="text-center mb-12" data-id="element-186">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-187">
              The Birth of FocusFlow
            </h2>
            <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl mt-4" data-id="element-188">
              I spent months testing blends. I didn't want a coffee dupe. I
              wanted an upgrade:
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-189">
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md" data-id="element-190">
              <div className="h-16 w-16 rounded-full bg-pink-100 flex items-center justify-center mb-4" data-id="element-191">
                <span className="text-2xl font-bold text-pink-600" data-id="element-192">1</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-center" data-id="element-193">Cacao</h3>
              <p className="text-gray-600 text-center" data-id="element-194">For mood & magnesium</p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md" data-id="element-195">
              <div className="h-16 w-16 rounded-full bg-pink-100 flex items-center justify-center mb-4" data-id="element-196">
                <span className="text-2xl font-bold text-pink-600" data-id="element-197">2</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-center" data-id="element-198">
                Chai spices
              </h3>
              <p className="text-gray-600 text-center" data-id="element-199">
                For warmth and digestion
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md" data-id="element-200">
              <div className="h-16 w-16 rounded-full bg-pink-100 flex items-center justify-center mb-4" data-id="element-201">
                <span className="text-2xl font-bold text-pink-600" data-id="element-202">3</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-center" data-id="element-203">Turmeric</h3>
              <p className="text-gray-600 text-center" data-id="element-204">
                For inflammation support
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md" data-id="element-205">
              <div className="h-16 w-16 rounded-full bg-pink-100 flex items-center justify-center mb-4" data-id="element-206">
                <span className="text-2xl font-bold text-pink-600" data-id="element-207">4</span>
              </div>
              <h3 className="text-xl font-bold mb-2 text-center" data-id="element-208">Adaptogens</h3>
              <p className="text-gray-600 text-center" data-id="element-209">
                For natural energy and mental performance
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-210">
            <p className="text-xl font-medium text-gray-900" data-id="element-211">
              The result? A rich, earthy drink that gives you steady,
              jitter-free energy.
            </p>
            <p className="text-xl font-medium text-pink-600 mt-4" data-id="element-212">
              Two weeks in, I had the most productive month of my life. No
              anxiety. No crash. Just clean, reliable focus.
            </p>
          </div>
        </div>
      </div>
    </section>;
}